module.exports = __webpack_public_path__ + "img/programacion-base.e7594480.jpg";